export default __webpack_public_path__ + "static/media/dashboard.c3ed34c9.svg";